<template>

    <div class="billing">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Faturamentos" sub="" />
        </div>

        <div id="pageGrid" v-show="!modalActive">
            <b-button id="btn-principal" variant="success" @click="addBilling()" size="lgx" class="mb-2" v-if="user.fat_adi">
                <i class="fa fa-plus"></i> Adicionar
            </b-button>

            <b-table :items="billings" :fields="fields"
                responsive 
                borderless
                striped
                medium>
                <template slot="status" slot-scope="data">
                    <b-badge style="padding:6px 0px 6px 0px; width: 130px;" 
                        :variant="getStatus(data.item.fl_status)">
                        {{data.item.status}}
                    </b-badge>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="primary" @click="loadBilling(data.item)" size="sm mr-2">  
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button id="btn-transmitir" variant="info" size="sm" class="mr-2" style="width: 250px; height: 40px;" 
                            :disabled="((data.item.fl_status === 'P') || (data.item.qtd_notas_mes === 0))" 
                            @click="transmitFaturamento(data.item)" 
                            v-if="user.fat_edi">Agendar Processamento
                    </b-button>
                </template>
            </b-table>
            <!--
            <b-pagination class="customPagination mt-4" size="md" v-model="page" :total-rows="count" :per-page="limit" />-->

            <b-pagination class="customPagination mt-4" size="md" v-model.trim="page" :total-rows="count" :per-page="limit" />

        </div>
        

        <div id="pageEdition" v-show="modalActive">
            <b-card :header="tituloModal"> 
                <b-form @submit.prevent="submit">
                    <b-row>
                        <b-col md="1" sm="12">
                            <b-form-group label="ID" label-for="billing-faturamento_id">
                                <b-form-input 
                                    type="text"
                                    id="billing-faturamento_id" 
                                    name="billing-faturamento_id" 
                                    ref="billing-faturamento_id" 
                                    v-model.trim="billing.faturamento_id" 
                                    readonly>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Mês/Ano" label-for="billing-mes_ano">
                                <b-form-input 
                                    type="text"
                                    id="billing-mes_ano" 
                                    name="billing-mes_ano" 
                                    ref="billing-mes_ano" 
                                    v-model.trim="billing.mes_ano" 
                                    readonly>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="9" sm="12">
                            <b-form-group label="*Empresa" label-for="billing-empresa_id">
                                <b-form-select 
                                    id="billing-empresa_id"
                                    name="billing-empresa_id"
                                    ref="billing-empresa_id"
                                    :options="companies" v-model.trim="billing.empresa_id" 
                                    :readonly="(!isInsert)"
                                    :class="{ 'form-control is-invalid' : $v.billing.empresa_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row v-if="(!isInsert)">
                        <hr>
                    </b-row>

                    <b-row v-if="(!isInsert)">
                        <b-col md="12" sm="12">
                            <b-card header='Itens do Faturamento'>

                                <div id="barraBotoes">
                                    <b-row>
                                        <b-col cols="12" class="text-left">
                                            <b-button id="btn-clientes" variant="primary" 
                                                @click="toggleClientes()" size="lgx" class="mb-2 mr-2" v-if="user.fat_adi">  
                                                <i class="fa fa-check"></i> Selecionar Clientes
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </div>   

                                <b-table :items="itens" :fields="fieldsItem"
                                    responsive 
                                    borderless
                                    striped
                                    medium>
                                    <template slot="status" slot-scope="data">
                                        <b-badge style="padding:6px 0px 6px 0px; width: 130px;" 
                                            :variant="getStatusItem(data.item.fl_status)">
                                            {{data.item.status}}
                                        </b-badge>
                                    </template>
                                    <template slot="nm_cliente" slot-scope="data">
                                        <span style="font-weight: 500;">{{ data.item.nm_cliente }}</span> <br>
                                        <span style="font-size: smaller;">{{ data.item.nm_produto }}</span>
                                    </template>
                                    <template slot="actions" slot-scope="data">
                                        <b-button variant="primary" title="Editar Item"    
                                            :disabled="((data.item.fl_status !== 'P') || (data.item.faturamento_item_id === null))"
                                            @click="loadItem(data.item)" 
                                            size="sm mr-2" v-if="user.fat_edi">   
                                            <i class="fa fa-pencil"></i>
                                        </b-button>                                      
                                        <b-button variant="danger" title="Excluir Item"   
                                            :disabled="((data.item.fl_status !== 'P') || (data.item.faturamento_item_id === null))"
                                            @click="removeItem(data.item)" 
                                            size="sm mr-2" v-if="user.fat_exc">  
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                    </template>
                                </b-table>    
                                
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                    </b-row>
  
                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 190px;"
                            @click="toggleModal">Cancelar
                        </b-button>  
                        <b-button id="btn-principal" variant="success" v-if="(isInsert)" class="mr-2" style="width: 190px;"
                            @click="saveBilling">Salvar
                        </b-button>
                        <b-button 
                            id="btn-principal"
                            variant="success" 
                            v-if="((!isInsert) && (this.$store.state.user.fat_edi))" 
                            class="mr-2" style="width: 190px;"
                            @click="saveBilling"><i class="fa fa-cog"></i> Gerar Faturas
                        </b-button>
                    </div>

                </b-form>        
            </b-card>
        </div>

        <b-modal ref="modalClientes" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Selecionar Clientes" size="xl">
            <template v-slot:modal-footer="{ saveAndTransmitNfse, limparFiltrosClientes }">
                <b-card header=""> 

                    <div class="mb-2">
                        <b-form-checkbox 
                            id="select-all"
                            v-model="checkedAll"
                            inline 
                            @change="checkAll()">
                            Selecionar todos
                        </b-form-checkbox>
                    </div>                    
                  
                    <b-table :items="clientes" :fields="fieldsClients"
                             :checked-all="checkedAll"
                             responsive 
                             borderless
                             striped
                             small>
                             <template slot="selected" slot-scope="data">
                                <b-form-group>
                                    <b-form-checkbox 
                                        v-model="data.item.selected" 
                                        variant="outline-secondary" 
                                        class="center">
                                    </b-form-checkbox>
                                </b-form-group>
                            </template>       
                    </b-table>                        
                </b-card> 

                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="secondary" class="mr-2" style="width: 150px;"
                            @click="limparFiltrosClientes()"> Fechar
                        </b-button>
                        <b-button 
                            v-b-modal.modal-prevent-closing
                            id="btn-principal"
                            variant="success" class="mr-2" style="width: 150px;"
                            @click="saveAndTransmitNfse()"><i class="fa fa-cog"></i> Salvar
                        </b-button>
                    </b-col>
                </b-row>                       

            </template>
        </b-modal>  

        <b-modal ref="modalItem" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Editar Item do Faturamento" size="lg">
            <template v-slot:modal-footer="{ saveItem, limparFiltrosItem }">
                <b-card header=""> 
                    <b-form @submit.prevent="submit">
                        <b-row>
                            <b-col md="2" sm="12">
                                <b-form-group label="ID" label-for="item-faturamento_item_id">
                                    <b-form-input 
                                        type="text"
                                        id="item-faturamento_item_id" 
                                        name="item-faturamento_item_id" 
                                        ref="item-faturamento_item_id" 
                                        v-model.trim="item.faturamento_item_id" 
                                        readonly>
                                    </b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col md="4" sm="12">
                                <b-form-group label="*Competência" label-for="item-dt_competencia">
                                    <b-form-input 
                                        type="text"
                                        id="item-dt_competencia" 
                                        name="item-dt_competencia" 
                                        ref="item-dt_competencia"
                                        v-model.trim="item.dt_competencia" 
                                        v-mask="'##/##/####'"
                                        placeholder="Informe competência">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col md="4" sm="12">
                                <b-form-group label="*Vlr. Fatura" label-for="item-vlr_fatura">
                                    <input 
                                        type="text" 
                                        id="item-vlr_fatura" 
                                        name="item-vlr_fatura" 
                                        ref="item-vlr_fatura" 
                                        style="text-align: right;"
                                        class="form-control" 
                                        v-model.trim="item.vlr_fatura" 
                                        v-money="money" /> 
                                </b-form-group>
                            </b-col>  
                        </b-row>

                        <b-row>
                            <b-col md="12" sm="12">
                                <b-form-group label="*Descrição da Nota" label-for="item-descricao">
                                    <b-form-textarea
                                        type="text"
                                        id="item-descricao" 
                                        name="item-descricao" 
                                        ref="item-descricao" 
                                        v-model.trim="item.descricao" 
                                        rows="3"
                                        max-rows="3">
                                    </b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-form> 

                </b-card> 

                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">

                        <b-button 
                            variant="success" class="mr-2" style="width: 150px;"
                            @click="saveItem()"><i class="fa fa-cog"></i> Salvar
                        </b-button>

                        <b-button variant="secondary" class="mr-2" style="width: 150px;"
                            @click="limparFiltrosItem()"> Fechar
                        </b-button>
                    </b-col>
                </b-row>                       

            </template>
        </b-modal>          

        <b-modal ref="modalTransmit" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Confirmação!">
            <p class="my-4">Deseja realmente enviar as NFS-e deste faturamento para processamento?</p>
            <template v-slot:modal-footer="{ saveAndtransmitFaturamento, hidetransmitFaturamento }">
                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="success" class="mr-2" style="width: 100px;"
                            @click="saveAndtransmitFaturamento()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideTransmitFaturamento()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>  
        
        <b-modal ref="modalRemove" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Confirmação!">
            <p class="my-4">Deseja realmente excluir este Item do Faturamento?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="success" class="mr-2" style="width: 100px;"
                            @click="confirmeRemove()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideRemove()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>                  
    </div>  
   
</template>

<script>
import { baseApiUrl, showError } from '@/global'

import { mapState } from 'vuex'

import axios from 'axios'

import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'

//import cnaesJson from '../../cache-data/cnaes.json'
//import servicesJson from '../../cache-data/listaservicos.json'

import { required } from "vuelidate/lib/validators";
import formMixin from '../../config/mixinform';

import {VMoney} from 'v-money'

import BEditableTable from 'bootstrap-vue-editable-table';

export default {
    name: 'Faturamentos',
    
    computed: { 
                ...mapState(['user']), 

                selected() {
                    return this.clientes.filter((cliente) => cliente.selected)
                },

                checkedLength () {
                    return this.clientes.filter(cliente => cliente.checked).length
                },

                allItemsChecked () {
                    return this.checkedLength === this.clientes.length
                }               
    },
     
    components: { PageTitle, Modal, BEditableTable },

    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            tituloModal: null,
            isInsert: false,      
            mesAno: null,

            modalItemActive: false,
            tituloItemModal: null,
           
            checkedAll: false,      

            billings: [],
            itens: [],

            billing: {},
            item: {},

            companies: [],
            
            fields: [
                { key: 'mes_ano', label: 'Mês/Ano' },
                { key: 'faturamento_id', label: 'ID' },
                { key: 'qtd_notas_mes', label: 'Qtd. Faturas' },
                { key: 'vlr_total_mes', label: 'Vlr. Total' },
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Ações', class: 'text-center' }
            ],
            page: 1,
            count: 0,
            limit: 0,

            fieldsItem: [
                { key: 'faturamento_item_id', label: 'Item' },
                { key: 'nm_cliente', label: 'Cliente' },
                { key: 'vlr_fatura', label: 'Vlr. Fatura' },
                { key: 'dt_competencia', label: 'Competência' },
                { key: 'status', label: 'Status' },
                { key: 'nfse_id', label: 'NFS-e ID' },
                { key: 'actions', label: 'Ações', class: 'text-center' }
            ],


            fieldsClients: [
                { key: 'selected', label: '', class: 'text-center' },
                { key: 'cliente_id', label: 'ID'},
                { key: 'nm_cliente', label: 'Cliente' },
                { key: 'nm_produto', label: 'Produto/Serviço' },
                { key: 'vlr_fatura', label: 'Vlr. Fatura' }
            ],

            clientes: [],

            pessoas: [
                    {
                        nome: "Alyadni e Catharina",
                        idade: "42",
                        localidade: "Cianorte - PR",
                        fl_status: "P"
                    },
                    {
                        nome: "Everson",
                        idade: "45",
                        localidade: "Umuarama - PR",
                        fl_status: "G"
                    },
                    {
                        nome: "João e Pedro",
                        idade: "15",
                        localidade: "Umuarama - PR",
                        fl_status: "P"
                    }
            ],

            money: {
                decimal: ',',
                thousands: '.',	
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false 
            },

            getStatus: (situacao) => {
                let classeSituacao;
                switch (situacao) {
                    case 'A':
                        classeSituacao = "primary";
                        break;
                    case 'P':
                        classeSituacao = "success";
                        break;
                    default:
                        classeSituacao = "secondary";
                }
                return classeSituacao;
            },

            getStatusItem: (situacao) => {
                let classeSituacao;
                switch (situacao) {
                    case 'P':
                        classeSituacao = "primary";
                        break;
                    case 'G':
                        classeSituacao = "info";
                        break;
                    case 'F':
                        classeSituacao = "success";
                        break;
                    default:
                        classeSituacao = "secondary";
                }
                return classeSituacao;
            },

        }
    },

    validations: {
        billing: {
            empresa_id: { required },
            mes_ano: { required },
        }  
    },

    directives: {money: VMoney},

    methods: {
        loadBillingies() {
            axios.get(`${baseApiUrl}/financeiro/faturamento/empresa/${this.$store.state.user.empsuser}/pagina/${this.page}`)
                 .then(resp => {
                     this.billings = resp.data.data
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)

            })
            //console.log('>>>>  ....loadBillingies()... >>')
            let obj = JSON.stringify(this.billings)
            console.log('billings >> '  + obj)

            console.log('this.page >> '  + this.page.toString())
            console.log('this.count >> '  + this.count.toString())
            console.log('this.limit >> '  + this.limit.toString())

        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresas/` + this.$store.state.user.userid)  
                 .then(resp => {
                     this.companies = resp.data.data.map(campany => {
                         return { value: campany.empresa_id, text: campany.nm_empresa }
                     })
            })
        },

        loadBilling(billing, mode = 'save') {
            this.mode = mode

            axios.get(`${baseApiUrl}/financeiro/faturamento/faturamento/${billing.faturamento_id}`)     
                 .then(resp => {
                     this.billing = resp.data.data
            })
            //console.log('EMPRESA SEL >> '  + this.billing.empresa_id)
            //let obj = JSON.stringify(this.billing)
            //console.log('FAT >> '  + obj)

            // Carrega Itens do Faturamento
            this.loadItens(billing)            

            this.tituloModal = 'Editar Faturamento'
            this.toggleModal()
        },

        loadItens(billing) {
            axios.get(`${baseApiUrl}/financeiro/faturamento/itens/${billing.faturamento_id}`)     
                 .then(resp => {
                     this.itens = resp.data.data
            })
        },

        addBilling() {
            this.billing = {}

            this.billing.mes_ano = this.getMesAnoAbreviado();

            this.tituloModal = 'Adicionar Faturamento'
            this.toggleModal()
            this.isInsert = true
        },

        toggleModal() {
            this.modalActive = !this.modalActive;
            if (this.modalActive === false) {
                this.reset()
            }

            // Redefinir erros de validação de formulário
            this.$v.$reset();            
		},

        reset() {
            this.mode = 'save'
            this.isInsert = false
            this.billing = {}
            this.loadBillingies()
        },

        focusFirstError() {
            var invalidFields = Object.keys(this.$v.$params)
                .filter(fieldName => this.$v[fieldName].$invalid);

            if (invalidFields) {
                this.$refs.input.$refs.input.focus()
            }
        },

        saveBilling() {
            if (this.validate()) {
                let payload = '';

                if (this.isInsert === true) {
                    payload = { 
                        'empresa_id': this.billing.empresa_id,
                        'mes_ano': this.billing.mes_ano, 
                        'faturamento_id': "",
                        'faturas': []
                    }
                } else {
                    const filtered = (filtro) => this.itens.filter(i => i.fl_status.includes(filtro));
                    const faturas = filtered('P')                
                    payload = { 
                        'empresa_id': this.billing.empresa_id,
                        'mes_ano': this.billing.mes_ano,
                        'faturamento_id': this.billing.faturamento_id,
                        'faturas': faturas
                    }
                }
                //let obj = JSON.stringify(payload)
                //console.log(obj)

                axios.post(`${baseApiUrl}/financeiro/gerarfaturamento`, payload) 
                    .then(resp => {
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                            this.billing = {}

                            // Refresh 
                            this.loadBillingies()

                        } else 
                        {
                            this.$toasted.global.defaultTest({ msg: resp.data.mensagem })
                            this.billing = {}
                        }
                    })
                    .catch(showError) 

                this.toggleModal()
            }
        },

        loadClientes() {
            axios.get(`${baseApiUrl}/financeiro/faturamento/clientes/empresa/${this.billing.empresa_id}`)
                .then(resp => {
                     this.clientes = resp.data.data
            })
        },        
 
        toggleClientes() {
            this.loadClientes();
            this.$refs.modalClientes.show();
		},

        limparFiltrosClientes() {
            this.$refs.modalClientes.hide();
            this.uncheckAll();
        },

        toggleSelect(item) {
          item.selected = !item.selected
        },
        
        checkAll() {
            let futureCheckedValue = true

            if (this.checkedAll) {
                futureCheckedValue = false
                this.checkedAll = false
            }
            else {
                this.checkedAll = true
            }
            this.clientes.forEach(item => item.selected = futureCheckedValue)
        },
        
        uncheckAll() {
            this.checkedAll = false;
            this.clientes.forEach(item => item.selected = false);
        },
        
        transmitFaturamento(billing) {
            this.billing = { ...billing } 
            this.$refs.modalTransmit.show();
        },

        hideTransmitFaturamento() { 
            this.$refs.modalTransmit.hide();
        },        

        saveAndtransmitFaturamento() {
            axios.post(`${baseApiUrl}/financeiro/faturamento/agendarprocessamento/${this.billing.faturamento_id}`) 
                .then(resp => {
                    if (resp.data.status) {
                        this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })

                        // Refresh 
                        this.loadBillingies()

                    } else 
                    {
                        this.$toasted.global.defaultWarning({ msg: resp.data.mensagem })
                    }
                })
                .catch(showError) 

            this.hideTransmitFaturamento();
        },


        saveAndTransmitNfse() {
            // Validacao se existe algum cliente selecionado 
            if (this.selected.length > 0) {
               
                let payload = '';
                payload = { 
                   'faturas': this.selected 
                }

                //let obj = JSON.stringify(payload)
                //console.log(obj)
                //console.log('saveAndTransmitNfse:1: FaturamentoID: ' + this.billing.faturamento_id)
                
                axios.post(`${baseApiUrl}/financeiro/gerarfaturamentoitens/faturamento/${this.billing.faturamento_id}`, payload) 
                    .then(resp => {
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem });
                            this.loadItens(this.billing);
                            this.limparFiltrosClientes();
                        } else 
                        {
                            this.$toasted.global.defaultTest({ msg: resp.data.mensagem });
                            this.limparFiltrosClientes();
                        }
                    })
                    .catch(showError) 
               
                //this.loadItens(this.billing) 
                //this.limparFiltrosClientes();
            } 
            else {
                this.$toasted.global.defaultWarning({ msg: 'É obrigatório selecionar ao menos um cliente para prosseguir!'})
            }
        },

        removeItem(billing) {
            this.billing = { ...billing } 
            this.$refs.modalRemove.show(billing);
        },

        hideRemove() { 
            this.$refs.modalRemove.hide();
        },

        confirmeRemove() { 
            this.hideRemove();

            const itemId = this.billing.faturamento_item_id
            const id = this.billing.faturamento_id

            axios.delete(`${baseApiUrl}/financeiro/faturamento/item/${itemId}/id/${id}`)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()

                     // Refresh 
                     this.loadItens(this.billing)            
                 })
                 .catch(showError)
        },

        loadItem(item) {
            axios.get(`${baseApiUrl}/financeiro/faturamento/item/${item.faturamento_item_id}`)
                .then(resp => {
                     this.item = resp.data.data
            })

            this.toggleItem();
        },        
 
        saveItem() {
            let payload = '';

            payload = { 
                    'faturamento_item_id': this.item.faturamento_item_id,
                    'faturamento_id': this.item.faturamento_id,
                    'dt_competencia': this.item.dt_competencia,
                    'vlr_fatura': this.item.vlr_fatura,
                    'descricao':  this.item.descricao,
            }
            //let obj = JSON.stringify(payload)
            //console.log(obj)

            axios.post(`${baseApiUrl}/financeiro/gerarfaturamentoitens/item`, payload) 
                .then(resp => {
                    if (resp.data.status) {
                        this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })

                        // Refresh 
                        this.loadItens(this.billing)            

                    } else 
                    {
                        this.$toasted.global.defaultTest({ msg: resp.data.mensagem })
                    }
                })
                .catch(showError) 

            this.limparFiltrosItem()
        },

        toggleItem() {
            this.$refs.modalItem.show();
		},

        limparFiltrosItem() {
            this.$refs.modalItem.hide();
        },
        
        getMesAno() {
            let dataAtual = new Date();
            var mesAno = (dataAtual.getUTCMonth() + 1).toString().padStart(2, '0') + '/' + dataAtual.getUTCFullYear();
            this.mesAno = mesAno;
        },
        
        getMesAnoAbreviado() {
            let dataAtual = new Date();
            var mesesAbreviados = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
            var mesAbreviado = mesesAbreviados[dataAtual.getUTCMonth()];
            var ano = dataAtual.getUTCFullYear();
            var mesAno = mesAbreviado + '/' + ano;
            return mesAno;
        }        

    },

    watch: {
        page() {
            this.loadBillingies()
        }
    },

    mounted() {
        this.loadBillingies() 
        this.loadCompanies() 
    }    
}

</script>

<style scoped>
    
    .title-emp {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }

</style>